import type { PaymentMethodStrategy } from "./types";

class MoneyPaymentMethod implements PaymentMethodStrategy {
  readonly id = "money" as const;
  readonly label = "Dinheiro";

  formatForWhatsApp(): string {
    return this.label;
  }

  isAvailable(): boolean {
    return true;
  }
}

class CreditCardPaymentMethod implements PaymentMethodStrategy {
  readonly id = "credit_card" as const;
  readonly label = "Cartão de crédito";

  formatForWhatsApp(): string {
    return this.label;
  }

  isAvailable(): boolean {
    return true;
  }
}

/** Registered for future use — enable when Google Pay is supported. */
class GooglePayPaymentMethod implements PaymentMethodStrategy {
  readonly id = "google_pay" as const;
  readonly label = "Google Pay";

  formatForWhatsApp(): string {
    return this.label;
  }

  isAvailable(): boolean {
    return false;
  }
}

export const paymentMethodRegistry: PaymentMethodStrategy[] = [
  new MoneyPaymentMethod(),
  new CreditCardPaymentMethod(),
  new GooglePayPaymentMethod(),
];
